import { isAfter, addSeconds } from 'date-fns';
type ScrollCords = Pick<Window, 'scrollX' | 'scrollY' | 'innerHeight'>;
type ScrollTo = [number, number];

const TIMEOUT_DURATION_SECONDS = 3;
const TIMEOUT_DELAY = 50;

let scrollHandle: number;
let scrollWidth: number;

function getScrollWidth() {
  const elm = document.createElement('div');
  elm.style.visibility = 'hidden';
  elm.style.overflow = 'scroll';
  document.body.appendChild(elm);
  const size = elm.offsetWidth - elm.clientWidth;
  elm.parentNode?.removeChild(elm);
  return size;
}

export function currentScrollPosition(w: ScrollCords): ScrollTo {
  const { scrollX, scrollY } = w;
  return [scrollX, scrollY];
}

export function currentScreenHeight() {
  return document.body.offsetHeight;
}

export function tryToScrollTo(scrollTo: ScrollTo, oldScreenHeight: number) {
  window.clearTimeout(scrollHandle);
  if (!scrollWidth) {
    scrollWidth = getScrollWidth();
  }
  const finalTry = addSeconds(Date.now(), TIMEOUT_DURATION_SECONDS);
  function scrollHandler() {
    if (isAfter(Date.now(), finalTry)) {
      window.scrollTo(0, 0);
      return;
    }
    const height = document.body.offsetHeight;
    if (height < oldScreenHeight) {
      scrollHandle = window.setTimeout(scrollHandler, TIMEOUT_DELAY);
      return;
    }
    window.scrollTo(...scrollTo);
  }
  scrollHandler();
}
